// NOTE: This file contains public API keys and URIs required for the frontend build.
// These are safe to expose for client-side use and are NOT secrets.

const dev = {
  mapsApiKey: "AIzaSyBOevggIYEqTjq-b07RlfRJxfEtG4b7-uI",
  apiBaseUri: "https://grocerbox.ngrok.io",
};

const prod = {
  mapsApiKey: "AIzaSyD41pbUg8GYDl_lmkSaM_EW1eyzHKB2kfQ",
  apiBaseUri: "https://api.getgrocerbox.com",
};

const config = process.env.REACT_APP_STAGE === "production" ? prod : dev;

export default {
  // Add common config values here
  ...config,
};
